import Blog from "@/Layouts/Blog";
import Contact from "@/Sections/Contact";
import { Head } from "@inertiajs/inertia-react";

export default () => {
    return (
        <Blog>
            <Head>
                <title>
                    Ontdek de kracht van Mateïne: Het alternatief voor cafeïne
                </title>
                <link rel="canonical" href={route("blogs.fifty-one")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="Hallo daar! Heb je ooit gehoord van mateïne? Nee? Dat dacht ik al! Hoog tijd om jou te introduceren aan deze geweldige stof. Mateïne is een natuurlijk stimulerend middel dat voorkomt in de yerba mate plant. Het is vergelijkbaar met cafeïne, maar dan zonder de nadelen. Klinkt goed, toch? Laten we eens duiken in de wereld van mateïne en ontdekken wat het voor jou kan betekenen."
                />
                <meta
                    property="og:description"
                    content="Hallo daar! Heb je ooit gehoord van mateïne? Nee? Dat dacht ik al! Hoog tijd om jou te introduceren aan deze geweldige stof. Mateïne is een natuurlijk stimulerend middel dat voorkomt in de yerba mate plant. Het is vergelijkbaar met cafeïne, maar dan zonder de nadelen. Klinkt goed, toch? Laten we eens duiken in de wereld van mateïne en ontdekken wat het voor jou kan betekenen."
                />
                <meta property="og:url" content={route("blogs.fifty-one")} />
                <meta property="og:type" content="article" />
                <meta
                    property="og:title"
                    content="Ontdek de kracht van Mateïne: Het alternatief voor cafeïne - WE ARE Personal Training Uden en Schijndel"
                />
                <meta property="og:image" content="/assets/blog/mateine.jpg" />
            </Head>

            <div className="bg-black">
                <div className="relative xs:h-[30vh] sm:h-[30vh] md:h-[65vh] lg:h-[65vh] pb-32">
                    <div>
                        <div className="absolute inset-0">
                            <picture>
                                <source
                                    srcSet="/assets/blog/webp/mateine.webp"
                                    type="image/webp"
                                    alt="Mateine"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <source
                                    srcSet="/assets/blog/mateine.jpg"
                                    type="image/png"
                                    alt="Mateine"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <img
                                    src="/assets/blog/mateine.jpg"
                                    alt="Mateine"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                            </picture>
                            <div
                                className="absolute inset-0 bg-gray-800 opacity-50 mix-blend-multiply"
                                aria-hidden="true"
                            />
                        </div>
                    </div>
                </div>
                <div className="xs:px-8 sm:px-8 md:px-16 lg:px-16 xs:py-12 sm:py-12 md:py-24 lg:py-24 max-w-7xl mx-auto">
                    <h1 className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-5xl sm:text-5xl md:text-6xl lg:text-6xl break-words">
                        Ontdek de kracht van Mateïne: Het alternatief voor
                        cafeïne
                    </h1>
                    <p className="mt-4 text-gray-100 break-words">
                        Hallo daar! Heb je ooit gehoord van mateïne? Nee? Dat
                        dacht ik al! Hoog tijd om jou te introduceren aan deze
                        geweldige stof. Mateïne is een natuurlijk stimulerend
                        middel dat voorkomt in de yerba mate plant. Het is
                        vergelijkbaar met cafeïne, maar dan zonder de nadelen.
                        Klinkt goed, toch? Laten we eens duiken in de wereld van
                        mateïne en ontdekken wat het voor jou kan betekenen.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Wat is Mateïne?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Mateïne is een xanthine alkaloïde, net als cafeïne,
                        theobromine (gevonden in chocolade) en theofylline
                        (gevonden in thee). Het is de primaire stimulerende stof
                        in de yerba mate plant, een plant die inheems is in
                        Zuid-Amerika en al eeuwenlang wordt gebruikt voor zijn
                        medicinale en stimulerende eigenschappen (Heck & de
                        Mejia, 2007).
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        De voordelen van Mateïne
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Maar wat maakt mateïne nou zo speciaal? Wel, het heeft
                        een aantal voordelen ten opzichte van cafeïne. Ten
                        eerste, in tegenstelling tot cafeïne, veroorzaakt
                        mateïne geen nervositeit of jittery gevoelens. Het geeft
                        je een soepele, gestage stroom van energie zonder de
                        onaangename crash die vaak volgt op een kop koffie
                        (Gorzalczany et al., 2001).
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Ten tweede, onderzoek heeft aangetoond dat mateïne kan
                        helpen bij gewichtsverlies door het verhogen van de
                        stofwisseling en het verminderen van de eetlust
                        (Andersen & Fogh, 2001). Het kan ook helpen bij het
                        verbeteren van de mentale focus en concentratie,
                        waardoor het een geweldig hulpmiddel is voor studie of
                        werk (Eisenstein et al., 2004).
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        In welke producten zit Mateïne?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        De meest voorkomende bron van mateïne is yerba mate
                        thee, een traditionele Zuid-Amerikaanse drank die wordt
                        bereid door de bladeren van de yerba mate plant te laten
                        trekken in heet water. Maar het is ook te vinden in
                        andere producten zoals energiedrankjes, supplementen en
                        zelfs in sommige soorten chocolade.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Hoeveel Mateïne per dag is gezond?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        De hoeveelheid mateïne die je per dag kunt consumeren
                        zonder negatieve bijwerkingen te ondervinden, hangt af
                        van je individuele tolerantie en gevoeligheid. Maar als
                        algemene richtlijn, wordt aangeraden om niet meer dan
                        400 mg mateïne per dag te consumeren (EFSA, 2015). Dat
                        is ongeveer het equivalent van vier koppen yerba mate
                        thee.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        En daar heb je het! Nu weet je alles wat je moet weten
                        over mateïne. Het is een natuurlijk, gezond alternatief
                        voor cafeïne dat je kan helpen om je energie en focus te
                        verbeteren zonder de onaangename bijwerkingen. Dus waar
                        wacht je nog op? Probeer het vandaag nog uit!
                    </p>
                    {/* -- */}
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl">
                        Referenties
                    </h3>
                    <p className="mt-4 text-gray-100 break-words">
                        De informatie in dit artikel is gebaseerd op betrouwbare
                        bronnen uit de literatuur.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Andersen, T., & Fogh, J. (2001). Weight loss and delayed
                        gastric emptying following a South American herbal
                        preparation in overweight patients. Journal of Human
                        Nutrition and Dietetics, 14(3), 243-250.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Eisenstein, J., Roberts, S. B., Dallal, G., & Saltzman,
                        E. (2002). High-protein weight-loss diets: are they safe
                        and do they work? A review of the experimental and
                        epidemiologic data. Nutrition reviews, 60(7), 189-200.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        EFSA. (2015). Scientific Opinion on the safety of
                        caffeine. EFSA Journal, 13(5), 4102.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Gorzalczany, S., Filip, R., Alonso, M. R., Miño, J.,
                        Ferraro, G. E., & Acevedo, C. (2001). Choleretic effect
                        and intestinal propulsion of ‘mate’ (Ilex
                        paraguariensis) and its substitutes or adulterants.
                        Journal of Ethnopharmacology, 75(2-3), 291-294.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Heck, C. I., & De Mejia, E. G. (2007). Yerba Mate Tea
                        (Ilex paraguariensis): a comprehensive review on
                        chemistry, health implications, and technological
                        considerations. Journal of Food Science, 72(9),
                        R138-R151.
                    </p>
                </div>
                <Contact />
            </div>
        </Blog>
    );
};
